import apiTool from './index';

const INVITE_USER_URL = 'kuser/invite-user/';
const COMPLETE_REGISTRATION_URL = 'kuser/process-registration/';
const CHANGE_PASSWORD = 'kuser/change-password/';
const GET_EMPLOYEE_URL = 'kuser/get-employee';
const ADD_USERFILE_URL = 'userprofile/add-userfile-request/';

export default {
  inviteUser(payload) {
    return apiTool.post(INVITE_USER_URL, payload);
  },
  completeRegistration(payload) {
    return apiTool.post(COMPLETE_REGISTRATION_URL, payload);
  },
  changePassword(payload) {
    return apiTool.post(CHANGE_PASSWORD, payload);
  },
  getEmployees(payload) {
    return apiTool.post(GET_EMPLOYEE_URL, payload);
  },
  addUserFile(payload) {
    return apiTool.post(ADD_USERFILE_URL, payload);
  },


};
